import {
  Buyer,
  Consignee,
  Consignor, Place,
  PreviousDocument,
  Seller,
} from 'shared/ncts/common/types'
import { FieldRequirement } from '../../../../../models/fieldRules'
import { NctsCountry } from '../../../../../../../config'
import { ServerValidationResult } from '../../../../../models/types'

export type GetHouseConsignmentFieldRequirementContext = {
  country?: string | null
  phase: 'p5' | 'p6'
  isOptIn: boolean
  security: string
  additionalDeclarationType: string
  specificCircumstanceIndicator: string
  valuesMap: Record<string, unknown>
  serverValidationResult?: ServerValidationResult
}

export type FieldRequirementResolverContext = {
  country?: string | null
  phase: 'p5' | 'p6'
  isOptIn: boolean
  security: string
  additionalDeclarationType: string
  specificCircumstanceIndicator?: string
  consignee?: Consignee
  consignor?: Consignor
  previousDocument?: PreviousDocument
  seller?: Seller
  buyer?: Buyer
  houseCountryOfDestination: string
  serverValidationResult?: ServerValidationResult
  differentSeller?: boolean
  differentBuyer?: boolean
  differentPlaceOfAcceptance?: boolean
  differentPlaceOfDelivery?: boolean
  differentCountriesOfRouting?: boolean
  placeOfDelivery?: Place
}

function stripPrefixes(serverValidationResult?: ServerValidationResult) {
  if (!serverValidationResult) return undefined

  const result: Record<string, FieldRequirement> = {}

  if (serverValidationResult?.fieldRequirements) {
    for (const [k, v] of Object.entries(serverValidationResult.fieldRequirements)) {
      let key = k
      if (key.startsWith('houseConsignment.*.')) {
        key = key.replace('houseConsignment.*.', '')
      }
      result[key] = v
    }
  }

  return {
    ...serverValidationResult,
    fieldRequirements: result,
  }
}

export function toFieldRequirementResolverContext(path: string, {
  country,
  phase,
  isOptIn,
  security,
  additionalDeclarationType,
  specificCircumstanceIndicator,
  valuesMap,
  serverValidationResult,
}: GetHouseConsignmentFieldRequirementContext): FieldRequirementResolverContext {
  let previousDocument
  if (path.startsWith('previousDocument.')) {
    const parts = path.split('.')
    const index = parts[1]
    const valueKey = `previousDocument.${index}`
    previousDocument = valuesMap[valueKey] as PreviousDocument | undefined
  }

  return {
    country: country ?? '' as NctsCountry,
    phase,
    isOptIn,
    security,
    specificCircumstanceIndicator,
    additionalDeclarationType,
    consignee: valuesMap.consignee as Consignee | undefined,
    consignor: valuesMap.consignor as Consignor | undefined,
    seller: valuesMap.seller as Seller | undefined,
    buyer: valuesMap.buyer as Buyer | undefined,
    houseCountryOfDestination: valuesMap.countryOfDestination as string ?? '',
    previousDocument,
    serverValidationResult: stripPrefixes(serverValidationResult),
    differentSeller: valuesMap.differentSeller as boolean | undefined,
    differentBuyer: valuesMap.differentBuyer as boolean | undefined,
    differentPlaceOfDelivery: valuesMap.differentPlaceOfDelivery as boolean | undefined,
    differentPlaceOfAcceptance: valuesMap.differentPlaceOfAcceptance as boolean | undefined,
    differentCountriesOfRouting: valuesMap.differentCountriesOfRouting as boolean | undefined,
    placeOfDelivery: valuesMap.placeOfDelivery as Place | undefined,
  }
}
